<footer class="bg-white text-grey py-4 text-sm">
  <div class="flex flex-col sm:flex-row-reverse sm:justify-between items-center container mx-auto py-2">
    <!-- Logo -->
    <a class="self-center mb-8 mt-4 sm:hidden" href="{{ environment.websiteUrl }}" appHomeLink>
      <img src="./assets/img/logo.svg" alt="Logo TotalEnergies" class="w-44" />
    </a>
    <!-- Consents & Privacy -->
    <ul class="flex flex-col sm:flex-row mb-8 sm:mb-0 text-grey-dark sm:text-opacity-70">
      <li class="sm:ml-4 my-2 text-center" [innerHTML]="'general.footer.privacy.item1' | translate"></li>
      <li
        class="sm:ml-4 my-2 text-center"
        [innerHTML]="'general.footer.privacy.item2' | translate"
        *ngIf="(businessTypeService.isB2BType$ | async) !== true"
      ></li>
      <li
        class="sm:ml-4 my-2 text-center"
        [innerHTML]="'general.footer.privacy.evcSmallBizitem1' | translate"
        *ngIf="businessTypeService.isB2BType$ | async"
      ></li>
      <li
        class="sm:ml-4 my-2 text-center"
        [innerHTML]="'general.footer.privacy.evcSmallBizitem2' | translate"
        *ngIf="businessTypeService.isB2BType$ | async"
      ></li>
    </ul>
    <div>
      <span class="ml-4 text-grey-dark">&copy; TotalEnergies 2021</span>
    </div>
  </div>
</footer>
